import { useQuery } from '@tanstack/react-query';
import { endpoints, withSideload } from '@rossum/api-client';
import {
  Annotation,
  AnnotationListSideload,
} from '@rossum/api-client/annotations';
import { ListResponse } from '@rossum/api-client/utils';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { api } from '../../../../lib/apiClient';
import { DISALLOWED_STATUSES_FILTER_ITEM } from '../../../document-list-columns/status/statuses';
import { encodeMqlQuery } from '../../../mql/encodeMqlQuery';
import { ACCESSIBLE_ANNOTATIONS_FILTER_ITEM } from '../../../pricing/utils';

const DEFAULT_ORDERING = '-created_at';
const SEARCH_ANNOTATIONS_QUERY_KEY = 'search-annotations';

type SearchAnnotationsProps = {
  query: { pageSize: number };
  filterItems: GridFilterItem[];
  uniqKey: string | null;
  sideloadRelations?: true;
};

type AttachmentsAnnotationListWithSideload = ListResponse<Annotation> &
  // These are always present
  Pick<AnnotationListSideload, 'documents' | 'modifiers'> &
  // These are present if relevant
  Partial<Pick<AnnotationListSideload, 'relations' | 'childRelations'>>;

export const useFilteredAnnotations = ({
  query,
  filterItems,
  uniqKey,
  sideloadRelations,
}: SearchAnnotationsProps) => {
  const mqlQuery = encodeMqlQuery([
    ...filterItems,
    ACCESSIBLE_ANNOTATIONS_FILTER_ITEM,
    DISALLOWED_STATUSES_FILTER_ITEM,
  ]);

  const querySuffix = filterItems.map(
    ({ field, operator }) => `${uniqKey}-${field}-${operator}`
  );

  return useQuery<AttachmentsAnnotationListWithSideload>({
    queryKey: [SEARCH_ANNOTATIONS_QUERY_KEY, querySuffix],

    queryFn: () =>
      api.request(
        withSideload(
          endpoints.annotations.search(
            { ...query, ordering: DEFAULT_ORDERING },
            { query: mqlQuery }
          ),
          {
            modifiers: true,
            documents: true,
            relations: sideloadRelations,
          }
        )
      ),

    enabled: !!uniqKey,
  });
};
